__turbopack_context__.v({
  "error-code": "error-information-module-scss-module__ss_yxq__error-code",
  "error-container": "error-information-module-scss-module__ss_yxq__error-container",
  "error-desc": "error-information-module-scss-module__ss_yxq__error-desc",
  "error-icon": "error-information-module-scss-module__ss_yxq__error-icon",
  "error-read-more": "error-information-module-scss-module__ss_yxq__error-read-more",
  "error-title": "error-information-module-scss-module__ss_yxq__error-title",
  "retry-button": "error-information-module-scss-module__ss_yxq__retry-button",
  "return-link": "error-information-module-scss-module__ss_yxq__return-link",
  "separator": "error-information-module-scss-module__ss_yxq__separator",
  "session-id": "error-information-module-scss-module__ss_yxq__session-id",
});
